export const ActionTypes = {
  TEAMS_FETCH: "TEAMS_FETCH",
  GROUPS_FETCH: "GROUPS_FETCH",
  RESET_GROUPS_FETCH: "RESET_GROUPS_FETCH",
  UPDATE_LOADER: "UPDATE_LOADER",
  SLOTS_FETCH: "SLOTS_FETCH",
  ALL_GROUPS_FETCH: "ALL_GROUPS_FETCH",
};
